import { type LocalP2PRoomMember, RoomPublication } from "@skyway-sdk/room";
import { atom } from "jotai";
import { wsStatus } from "types";

export const wsStatusAtom = atom<wsStatus>("closed");
export const myStreamAtom = atom<any>(null);
export const siteCodeAtom = atom<string>("");
export const sessionIdAtom = atom<string>("");
export const myCameraAtom = atom<boolean>(true);
export const requestUrlAtom = atom<string>("");
export const finishModalIsOpenAtom = atom<boolean>(false);
export const timeoutModalIsOpenAtom = atom<boolean>(false);
export const systemErrorModalIsOpenAtom = atom<boolean>(false);
export const recallModalIsOpenAtom = atom<boolean>(false);
export const anotherTabCallingAtom = atom<boolean>(false);
export const recallCountAtom = atom<number>(0);
export const useMyVideoAtom = atom<boolean>(false);
export const meAtom = atom<LocalP2PRoomMember | undefined>(undefined);
export const remoteAudioPublicationAtom = atom<RoomPublication | undefined>(
  undefined
);
export const remoteVideoPublicationAtom = atom<RoomPublication | undefined>(
  undefined
);

export const currentAudioDeviceIdAtom = atom<string>("");
export const currentVideoDeviceIdAtom = atom<string>("");
